module.exports = __webpack_public_path__ + "img/portMappingCover.ffe93409.jpg";